<template>
  <div class="product_inf" style="">
    <card
      title="获证组织简介"
      v-if="ObtainOrganization && (ObtainOrganization.isShow === undefined || ObtainOrganization.isShow) &&productType==0">
      <!--      <div style="text-align: center">-->
      <!--        <img :src="logo" style="width: 4rem"/>-->
      <!--        <span style="color:#FFF">-->
      <!--        </span>-->
      <!--      </div>-->
      <div class="product_inf_content" style="padding:0rem 2rem 0.6rem 1.8rem;">
        <span class="inlineblock width100 yellowfont minfont widthStyle">
            <p v-html="ObtainOrganization.msgContent"></p>
          <!--          {{ ObtainOrganization.msgContent }}-->
          <!--          &nbsp;&nbsp;&nbsp;&nbsp;2015年落户溧水区的南京金色庄园农产品有限公司是一家主要从事草莓种植、加工与销售的农业产业化国家重点龙头企业，公司通过“统一种苗、统一植保、统一农资供应、统一标准、统一品牌管理、统一市场销售”的“六统一”管理模式,实现产业标准化。目前，公司培育出来的种苗成活率达到了98%以上，已自建标准化草莓基地8000亩，合作建设基地30000亩，正式签约的农户共有7000户。-->
        </span>
      </div><!--滑动门背景增加代码-->
      <div style="width: 100%;overflow: hidden;padding:1rem 2rem 0.6rem 1.8rem;">
        <img :src="ObtainOrganization.organization" style="width: 100%"/>
      </div>
    </card>
    <card
      title="企业介绍"
      v-if="ObtainOrganization && (ObtainOrganization.isShow === undefined || ObtainOrganization.isShow)&&productType==1">
      <div style="text-align: center">
        <img :src="logo" style="width: 8rem"/>
      </div>
      <div class="product_inf_content" style="padding:0rem 2rem 0.6rem 1.8rem;">
        <span class="inlineblock width100 yellowfont minfont">
            <p v-html="ObtainOrganization.msgContent"></p>

          <!--          深圳禾顺农业有限公司总部位于深圳市坪山区龙田街道龙田社区田欢路8号,公司于2018年成立,至今已经营5年。是一家从事芽苗菜工厂化种植培育、加工包装、销售的公司。-->
           </span>
        <!--        <span class="inlineblock width100 yellowfont minfont">-->
        <!--            禾顺农业以自主研发的综合水处理系统、物联网及数字化综合控制体系为核心,打造低碳芽苗菜植物工厂,以GAP中国良好农业规范认证和食品安全体系认证FSSC22000、SO22000:2018管理体采认证、危害分析与关键控制点HACCP(V1.0)体系认证为生产基础,始终坚持0化学添加的种植生产过程为消费者提供真正的可放心食用的健康芽苗菜产品。-->
        <!--      </span>-->
      </div><!--滑动门背景增加代码-->
      <div style="width: 100%;overflow: hidden;padding:1rem 2rem 0.6rem 1.8rem;">
        <img :src="ObtainOrganization.organization" style="width: 100%"/>
      </div>
    </card>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'

  export default {
    name: '',
    props: {
      ObtainOrganization: {
        type: Object,
        default: () => ({
          isShow: true,
          msgContent: '',
          organization: ''
        })
      },
      productType: {
        type: Number,
        default: 0
      }
    },
    components: { card },
    data() {
      return {
        logo: require('../../../assets/logo1.png'),
        factory: require('../../../assets/card/factory.png')
      }
    },
    methods: {}
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 14rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}
</style>
